import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import 'animate.css';
import Countdown from 'react-countdown';

import IconCloseBlack from '../../assets/icons/icon-close-black.svg';
import maintainUtm, { generateButtonId } from '../../services/maintainUtm';
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

import * as S from './styles';

export const compendioG = "@compendioG";

const allowedRoutes = [
    "/planos",
    "/receituario-agronomico-2024",
    '/receituario-agronomico-2026',
    '/receituario-agronomico-2026b'
];

const CountdownBlackLp = ({ onVisibilityChange, campaign, ...props }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    const [isVisible, setIsVisible] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [utmUrl, setUtmUrl] = useState('');
    const [rotas, setRotas] = useState([]);

    useEffect(() => {
        if (campaign) {
            const currentPageId = getCurrentPageIdWithDevice();
            const buttonId = generateButtonId(campaign.nome_campanha, `${currentPageId}`, `${currentPageId}-contadortopo`);
            const search = maintainUtm(buttonId);
            let url = `/planos${search}`;

            if (!url.includes('cupom=')) {
                url += `&cupom=${campaign.agro_coupon.nome_cupom}`;
            }

            setUtmUrl(url);
        }
    }, [campaign]);

    const initializeOrUpdateRoutes = () => {
        const storedRoutes = localStorage.getItem('allowedRoutes');
        if (!storedRoutes) {
            localStorage.setItem('allowedRoutes', JSON.stringify(allowedRoutes));

            setRotas(allowedRoutes);
        } else {
            const parsedStoredRoutes = JSON.parse(storedRoutes);

            const newRoutes = allowedRoutes.filter(route => !parsedStoredRoutes.includes(route));
            
            if (newRoutes.length > 0) {
                const updatedRoutes = [...parsedStoredRoutes, ...newRoutes];
                localStorage.setItem('allowedRoutes', JSON.stringify(updatedRoutes));
                setRotas(updatedRoutes);
            } else {
                setRotas(parsedStoredRoutes);
            }
        }
    };

    useEffect(() => {
        initializeOrUpdateRoutes();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const getDiscountText = () => {
        const descriptionHtml = campaign?.descricao || '';
        return (
            <>
                {width > 767 && <h2 style={{ fontFamily: "Lato",fontSize: 17,fontWeight: 800,lineHeight: "1.3em",color: "#FFFFFF" }}>{campaign?.nome_campanha}</h2>}
                <p style={{ textAlign: width > 767 ? "left" : "center" }} dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
            </>
        );
    };

    const currentDate = new Date();
    const baseTarget = campaign?.data_final ? new Date(campaign.data_final) : new Date('2025-11-30T23:59:59');
    const targetDate = new Date(baseTarget.getTime() + 3 * 60 * 60 * 1000);


    const handleClose = () => {
        setIsAnimating(true);

        setTimeout(() => {
            setIsVisible(false);
            if (typeof onVisibilityChange === 'function') {
                onVisibilityChange(false);
            }
        }, 500);
    };

    useEffect(() => {
        onVisibilityChange(isVisible);
    }, [isVisible, onVisibilityChange]);


    const headTimerRenderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return null;
        } else {
            return (
                <S.HeaderContainerCountdown>
                    <S.HeaderContainerBlock>
                        <span>{days}</span>

                        <span>dias</span>
                    </S.HeaderContainerBlock>

                    <S.HeaderContainerBlock>
                        <span>{hours}</span>

                        <span>horas</span>
                    </S.HeaderContainerBlock>

                    <S.HeaderContainerBlock>
                        <span>{minutes}</span>

                        <span>minutos</span>
                    </S.HeaderContainerBlock>

                    <S.HeaderContainerBlock>
                        <span>{seconds}</span>

                        <span>segundos</span>
                    </S.HeaderContainerBlock>
                </S.HeaderContainerCountdown>
            );
        }
    };
    const getUserPlan = localStorage.getItem('@plan_name');
    if (!campaign) return null;
    if (!isVisible || currentDate > targetDate) {
        return null;
    }

    const containerClass = isAnimating ? 'animate__animated animate__fadeOutUp' : '';

    if (rotas.includes(currentPath)) {
        return (
            <S.HeadContainer className={containerClass}>
                <S.HeaderPromo>
                    <S.HeaderPromoTitleAndTimer>
                        <S.HeaderTimer>
                            <Countdown date={targetDate} renderer={headTimerRenderer} />
                        </S.HeaderTimer>

                        <S.HeadDescription>
                            {getDiscountText()}
                        </S.HeadDescription>
                    </S.HeaderPromoTitleAndTimer>

                    <a href={window.location.pathname === '/receituario-agronomico-2026' ? '#teste-gratis': utmUrl}>
                        <button>
                            <p styled={{noWrap: true}}>Garantir desconto</p>
                        </button>
                    </a>

                    <button onClick={handleClose}>
                        <img src={IconCloseBlack} alt="Fechar" />
                    </button>
                </S.HeaderPromo>
            </S.HeadContainer>
        );
    }
};

export default CountdownBlackLp;